import Promoters from '@/components/promoters/Promoters'
import PromoterDetail from '@/components/promoters/PromoterDetail'
import PromoterCreate from '@/components/promoters/PromoterCreate'
import ComisionCreate from '@/components/promoters/comisions/ComisionCreate'
import PaymentCreate from '@/components/promoters/payments/PaymentCreate'
import ComisionDetail from '@/components/promoters/comisions/ComisionDetail'
import PaymentDetail from '@/components/promoters/payments/PaymentDetail'
import PromoterUpdate from '@/components/promoters/PromoterUpdate'

const promotersRoutes = [
  { path: '/promoters', name: 'promoters', component: Promoters },
  { path: '/promoter/create', name: 'promoter_create', component: PromoterCreate },
  { path: '/comision/create/:id', name: 'comision_create', component: ComisionCreate },
  { path: '/payment/create/:id', name: 'payment_create', component: PaymentCreate },
  { path: '/promoter/update/:id', name: 'promoter_update', component: PromoterUpdate },
  { path: '/promoter/:id', name: 'promoter', component: PromoterDetail },
  { path: '/comision/:id', name: 'comision', component: ComisionDetail },
  { path: '/payment/:id', name: 'payment', component: PaymentDetail }
]

export default promotersRoutes



// WEBPACK FOOTER //
// ./src/router/promoters_routes.js